import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/Aditya100401/aditya100401.github.io'
      className='link footer__link'
    >
      Created with <span role="img" aria-label="heart">❤️</span> by Aditya Sampath
    </a>
  </footer>
)

export default Footer
